import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=547bb282&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=547bb282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547bb282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547bb282')) {
      api.createRecord('547bb282', component.options)
    } else {
      api.reload('547bb282', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=547bb282&scoped=true&", function () {
      api.rerender('547bb282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/SearchFilterTokens.vue"
export default component.exports